export default __webpack_public_path__ + "static/media/html.185baee7.svg";